<template>
  <div class="white_box">
    <h3>{{ guideInfo.title }}</h3>
    <h5 v-html="guideInfo.intro"></h5>
    <div class="img_box">
      <img :src="guideInfo.img" />
    </div>
    <el-button class="btn_open" type="primary" @click="open(guideInfo.type)">立即开店</el-button>
  </div>
</template>

<script>
export default {
  props: {
    guideInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    open(type) {
      if (type == 'plus') {
        this.$router.push({ path: `/openStore.html` })
      } else {
        this.$router.push({ path: `/brandStore.html` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.white_box {
  width: 440px;
  height: 624px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  position: absolute;
  top:50%;
  margin-top: -317px;
  h3 {
    font-size: 30px;
    color: #333;
    line-height: 1.2;
  }
  h5 {
    height: 50px;
    font-size: 16px;
    font-weight: normal;
    color: #666;
    line-height: 1.5;
    margin-top: 25px;
  }
  .img_box {
    width: 350px;
    height: 240px;
    margin: 60px 0 60px;
    img {
      width: 350px;
      height: 240px;
    }
  }
  .btn_open {
    width: 338px;
    height: 60px;
    background: rgba(254, 222, 44, 1);
    border-radius: 10px;
    font-weight: 500;
    color: rgba(46, 45, 45, 1);
    border: none;
    font-size: 24px;
    padding: 0 20px;
    line-height: 60px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px){
    width: 350px;
    height: 500px;
    border-radius: 10px;
    padding: 40px 0 30px;
    /* top: 55px; */
    margin-top: -250px;
    .img_box {
      margin: 20px 0;
      width: 300px;
      height: 205px;
      img {
        width: 300px;
        height: 205px;
      }
    }
    .btn_open {
      width: 80%;
      font-size: 20px;
      border-radius: 5px;
      height: 50px;
      line-height: 50px;
    }
  }
  @media screen and (min-width: 1024px) and (max-width:1366px){
    width: 320px;
    height: 458px;
    border-radius: 10px;
    padding: 30px 0;
    /* top: 45px; */
    margin-top: -226px;
    h3 {
     font-size: 24px;
    }
    h5 {
      font-size: 16px;
    }
    .img_box {
      margin: 20px 0;
      width: 280px;
      height: 190px;
      img {
        width: 280px;
        height: 190px;
      }
    }
    .btn_open {
      width: 80%;
      font-size: 18px;
      border-radius: 5px;
      height: 50px;
      line-height: 50px;
    }
  }
  @media screen and (min-width: 1400px) and (max-width: 1600px){
    width: 350px;
    height: 500px;
    border-radius: 10px;
    padding: 30px 0;
    /* top: 70px; */
    margin-top: -250px;
    .img_box {
      margin: 20px 0;
      width: 300px;
      height: 205px;
      img {
        width: 300px;
        height: 205px;
      }
    }
    .btn_open {
      width: 80%;
      font-size: 20px;
      border-radius: 5px;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>